(async () => {
  if (!customElements.get('account-snackbar')) {
    const { default: Cookies } = await import('js-cookie');

    class accountSnackbar extends HTMLElement {
      constructor() {
        super();

        //only on desktop
        if (window.screen.width >= 768) {
          this.logout = document.querySelector('[data-logout]');

          // cookie states at loading
          this.loginCookie = Cookies.get('login') ? true : false;
          this.active = Cookies.get('active') ? true : false;

          if (this.logout) {
            this.logout.addEventListener('click', () => {
              Cookies.remove('login');
              Cookies.remove('active');
            });
          }

          //  if login cookie does not exist => show it & set it
          if (!this.loginCookie) {
            Cookies.set('login', 'true', { expires: 365 });
          }

          window.addEventListener('load', () => {
            const loginCookie = Cookies.get('login') ? true : false;
            const active = Cookies.get('active') ? true : false;

            if (loginCookie && !active) {
              this.classList.remove('hidden');

              setTimeout(() => {
                this.classList.add('hidden');
              }, 4000);

              Cookies.set('active', 'true', { expires: 1 });
            }
          });
        }
      }
    }
    window.accountSnackbar = accountSnackbar;
    customElements.define('account-snackbar', accountSnackbar);
  }
})();
